import { render, staticRenderFns } from "./likeTask.vue?vue&type=template&id=0f421f7a&scoped=true&"
import script from "./likeTask.vue?vue&type=script&lang=js&"
export * from "./likeTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f421f7a",
  null
  
)

export default component.exports